import React from 'react'
import { Grid, GridCell, Text, View } from 'oio-react'
import PropTypes from 'prop-types'

const MetadataListItemRow = ({
   action,
   description,
   id,
   keyName,
   value
}) => (
   <View
      width="100%"
      padding="20px"
      backgroundColor="#fff"
      borderBottom="1px solid #eee">
      <Grid columns="7">
         <GridCell colspan="3">
            <View
               float="left"
               padding="1px 3px"
               backgroundColor="#fff">
               <Text
                  fontFamily="courier"
                  size="1.5"
                  weight="bold"
                  color="#333">
                  {keyName}
               </Text>
            </View>
         </GridCell>
         <GridCell colspan="3">
            <View
               float="left"
               padding="1px 3px"
               backgroundColor="rgba(255,229,100,0.2)">
               <Text
                  fontFamily="courier"
                  size="1.5"
                  color="#333">
                  {value}
               </Text>
            </View>
            <View
               float="left"
               width="100%"
               marginTop="5px"
               paddingTop="5px"
               borderTop="1px solid #eee">
               <Text
                  size="1.5"
                  color="#888">
                  {description}
               </Text>
            </View>
         </GridCell>
         <GridCell>
            <View
               float="right"
               display="flex"
               alignItems="center"
               flex="0 0 auto"
               position="relative"
               width="30px">
               {action}
            </View>
         </GridCell>
      </Grid>
   </View>
)

MetadataListItemRow.propTypes = {
   action: PropTypes.node.isRequired,
   description: PropTypes.string.isRequired,
   id: PropTypes.string.isRequired,
   keyName: PropTypes.string.isRequired,
   value: PropTypes.string.isRequired
}

export default MetadataListItemRow
